<template>
  <div class="ProductionList">
    <div class="tableFilter">
      <el-form :inline="true" :model="filter" size="small" ref="form">
        <el-form-item label="课包分类:" prop="category">
          <el-select
              v-model="filter.category"
              filterable
              placeholder="请选择"
              style="width: 100px"
              @change="onSubmit"
          >
            <el-option
                v-for="item in productionTypeOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付费方式" v-show="permissionCode.has('research:product:price')">
          <el-select
              style="width: 100px"
              v-model="filter.paymentMethod"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in payOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
              style="width: 100px"
              v-model="filter.states"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in productStatesOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架时间">
          <el-date-picker
              style="width: 220px"
              v-model="filter.dateRange"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSubmit"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-input
              style="width: 150px"
              v-model="filter.keyword"
              placeholder="课包名称 | 主讲老师"
              @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查找</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="primary" @click="handleProductCategory" plain
                   v-show="permissionCode.has('research:product:manager')"
        >管理分类
        </el-button>
        <el-button type="primary" @click="handleAddProduction" plain
                   v-show="permissionCode.has('research:product:manager')"
        >发布课包
        </el-button>
      </div>
    </div>
    <XTable
        :api="getProductResponseList"
        :state="productList"
        :columns="columns"
        :loading="isBack"
        :tableSize="tableSize"
        :maxHeight="maxHeight"
        :layout="layout"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import {
  PRODUCTION_STATES,
} from "@/utils/constants";

export default {
  name: "ProductionList",
  components: {XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    const productStatesOption = Object.keys(PRODUCTION_STATES).map((key) => {
      return {
        value: Number(key),
        label: PRODUCTION_STATES[key],
      };
    });
    return {
      hasPagination: true,
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      back: false,
      productionTypeOption: [
        {
          id: null,
          name: "全部",
        }
      ],
      productStatesOption: [
        {
          value: null,
          label: "全部",
        },
        ...productStatesOption,
      ],
      payOptions: [
        {
          value: null,
          label: "全部",
        },
        {
          value: 0,
          label: "免费学习",
        },
        {
          value: 1,
          label: "付费学习",
        },
      ],
    };
  },
  computed: {
    ...mapState("teachingCenter", [
      "productList",
      "productListLoading",
      "isBack",
    ]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.teachingCenter.productListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "productListFilter",
          value,
        });
      },
    },
    isUp() {
      return this.productList.page === 1;
    },
    isDown() {
      return (
          this.productList.total -
          (this.productList.page - 1) * this.productList.size -
          1
      );
    },
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "id",
          label: "课包编号",
        },
        {
          prop: "name",
          label: "课包名称",
        },
        {
          label: "主讲老师",
          render(h, scope) {
            return (
                <div>
              <span>
                {scope.row &&
                    scope.row.nicknames &&
                    scope.row.nicknames.join(" | ")}
              </span>
                </div>
            );
          },
        },
        {
          label: "上架时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.upperTime)}</span>
                </div>
            );
          },
        },
        {
          label: "下架时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.downTime)}</span>
                </div>
            );
          },
        },
        {
          prop: "states",
          label: "状态",
          render(h, scope) {
            return (
                <div>
                  <span>{PRODUCTION_STATES[scope.row.states]}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('research:product:price')) {
        columns.push(...[
          // {
          //   prop: "paymentMethod",
          //   label: "付费方式",
          //   render(h, scope) {
          //     return (
          //         <div>
          //           <span>{PAY_TYPE[scope.row.paymentMethod]}</span>
          //         </div>
          //     );
          //   },
          // },
          // {
          //   prop: "validityCustom",
          //   label: "有效期",
          //   render() {
          //     return (
          //         <div>
          //           <div class="textBox">永久有效</div>
          //         </div>
          //     );
          //   },
          // },
          {
            label: "课包价格",
            render(h, scope) {
              return (
                  <div>
                    <span>{self.price(scope.row.salePrice)}</span>
                  </div>
              );
            },
          },
          {
            label: "销量",
            render(h, scope) {
              return <div>{(scope.row && scope.row.saleCount) || 0}</div>;
            },
          },
        ])
      }
      if (this.permissionCode.has('research:product:manager')) {
        columns.push({
          label: "调整顺序",
          width:
              150,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={self.isUp && scope.$index === 0}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={self.isDown == scope.$index}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          }
        });
        columns.push({
          label: "操作",
          fixed:
              "right",
          width:
              250,
          render(h, scope) {
            return (
                <div>
                  {scope.row.states === 1 && (
                      <el-button
                          onClick={() => {
                            self.handleDownProduct(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        下架
                      </el-button>
                  )}
                  {scope.row.states === 0 && (
                      <el-button
                          onClick={() => {
                            self.handleUpProduct(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        上架
                      </el-button>
                  )}
                  {!scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleEdit(scope.row);
                          }}
                          // disabled={scope.row.states === 1}
                          size="mini"
                          type="primary"
                          plain
                      >
                        编辑
                      </el-button>
                  )}
                  {!scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleDelete(scope.row);
                          }}
                          // disabled={scope.row.states === 1}
                          size="mini"
                          type="danger"
                          plain
                      >
                        删除
                      </el-button>
                  )}
                </div>
            );
          }
          ,
        });
      }
      return columns;
    }
  },
  async mounted() {
    this.productionTypeOption.push(...await this.getCachedProductCategoryList());
  },
  methods: {
    ...mapActions("teachingCenter", [
      "getProductResponseList",
      "getCachedProductCategoryList",
      "moveProduct",
      "deployProduct",
      "deleteProduct",
    ]),
    ...mapMutations("teachingCenter", ["clearFilter"]),
    async handleAddProduction() {
      await this.$router.push(
          {
            name: "AddProduction",
            params: {
              type: "add",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    async handleProductCategory() {
      await this.$router.push(
          {
            name: "productCategory",
          },
          () => {
          }
      );
    },
    // 搜索
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getProductResponseList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    //重置
    onReset() {
      this.clearFilter();
      this.getProductResponseList({
        page: 1,
      });
    },
    price(val) {
      if (!val) {
        return 0;
      } else {
        return val / 100;
      }
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const offset =
          (this.productList.page - 1) * this.productList.size + scope.$index + 1;
      this.move;
      await this.moveProduct({
        ...this.filter,
        previewDirect: previewDirect,
        offset: offset,
        step: 1,
      }).then(() => {
        this.getProductResponseList({
          ...this.filter,
          page: this.productList.page,
          size: this.productList.size,
        })
      });
    },
    async handleEdit(row) {
      localStorage.setItem("productDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "AddProduction",
            params: {
              type: "edit",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    handleDelete(row) {
      this.$confirm("删除课包后不可找回,请确认是否继续删除!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deleteProduct({
              id: row.id,
            });
            await this.getProductResponseList({
              page: this.productList.page,
              size: this.productList.size,
            });
          })
          .catch(() => {
          });
    },
    async handleDownProduct(row) {
      this.$confirm("请确认是否要下架该课包!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deployProduct({
              id: row.id,
              states: 0,
            });
            await this.getProductResponseList({
              page: this.productList.page,
              size: this.productList.size,
            });
          })
          .catch(() => {
          });
    },
    async handleUpProduct(row) {
      this.$confirm("请确认是否要上架该课包!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deployProduct({
              id: row.id,
              states: 1,
            });
            await this.getProductResponseList({
              page: this.productList.page,
              size: this.productList.size,
            });
          })
          .catch(() => {
          });
    },
    // 根据时间戳计算上传日期
    formatDate(timestamp) {
      return DateUtil.formatDateCommitTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.ProductionList {
  .tableFilter {
    padding-bottom: 10px;
  }

  .el-form-item {
    margin-right: 20px;
  }

  ::v-deep .el-range-separator {
    width: 20px !important;
  }
}
</style>
